import { render, staticRenderFns } from "./chooseUserDialog.vue?vue&type=template&id=b0a76940&scoped=true&lang=pug&"
import script from "./chooseUserDialog.vue?vue&type=script&lang=js&"
export * from "./chooseUserDialog.vue?vue&type=script&lang=js&"
import style0 from "./chooseUserDialog.vue?vue&type=style&index=0&id=b0a76940&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a76940",
  null
  
)

export default component.exports